import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "exam-ticket-box",
  id: "exam-ticket"
};
var _hoisted_2 = {
  key: 0
};
var _hoisted_3 = {
  key: 1
};
var _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "准考证", -1);
var _hoisted_5 = {
  class: "container"
};
var _hoisted_6 = {
  class: "table-container"
};
var _hoisted_7 = {
  class: "table"
};
var _hoisted_8 = /*#__PURE__*/_createElementVNode("td", {
  class: "td1"
}, "组别", -1);
var _hoisted_9 = {
  rowspan: "9",
  class: "photo"
};
var _hoisted_10 = ["src"];
var _hoisted_11 = /*#__PURE__*/_createElementVNode("td", {
  class: "td1"
}, "省份", -1);
var _hoisted_12 = /*#__PURE__*/_createElementVNode("td", {
  class: "td1"
}, "准考证号", -1);
var _hoisted_13 = /*#__PURE__*/_createElementVNode("td", {
  class: "td1"
}, "测试时间", -1);
var _hoisted_14 = /*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("td", {
  class: "td1"
}, "认证语言"), /*#__PURE__*/_createElementVNode("td", null, "C++")], -1);
var _hoisted_15 = /*#__PURE__*/_createElementVNode("td", {
  class: "td1"
}, "姓名", -1);
var _hoisted_16 = /*#__PURE__*/_createElementVNode("td", {
  class: "td1"
}, "性别", -1);
var _hoisted_17 = /*#__PURE__*/_createElementVNode("td", {
  class: "td1"
}, "证件号", -1);
var _hoisted_18 = /*#__PURE__*/_createElementVNode("td", {
  class: "td1"
}, "学校", -1);
var _hoisted_19 = /*#__PURE__*/_createElementVNode("td", {
  class: "td1"
}, "考场", -1);
var _hoisted_20 = {
  colspan: "2"
};
var _hoisted_21 = /*#__PURE__*/_createElementVNode("td", {
  class: "td1"
}, "座位号", -1);
var _hoisted_22 = {
  colspan: "2"
};
var _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "footer"
}, " 提醒：为避免考场及座位号信息有变动，请务必于考前1-3天再次登录系统确认考场和座位号 ", -1);
var _hoisted_24 = {
  class: "text-center",
  style: {
    "margin-top": "20px"
  }
};
var _hoisted_25 = /*#__PURE__*/_createTextVNode(" 下载准考证 ");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_spin = _resolveComponent("a-spin");
  var _component_a_button = _resolveComponent("a-button");
  var _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.data.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.data.visible = $event;
    }),
    width: 920,
    title: "准考证下载",
    header: null,
    footer: null,
    "mask-closable": false,
    centered: true,
    class: "exam-ticket-dialog"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_spin, {
        spinning: _ctx.loading
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_ctx.resData.title ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.resData.title), 1)) : (_openBlock(), _createElementBlock("h1", _hoisted_3, " CSP-X " + _toDisplayString(_ctx.resData.activityTerm) + " " + _toDisplayString(_ctx.resData.stageName) + " - " + _toDisplayString(_ctx.resData.scheduleName), 1)), _hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("table", _hoisted_7, [_createElementVNode("tr", null, [_hoisted_8, _createElementVNode("td", null, _toDisplayString(_ctx.resData.scheduleName), 1), _createElementVNode("td", _hoisted_9, [_createElementVNode("img", {
            class: "avatar",
            src: _ctx.resData.avatar,
            alt: "考生照片"
          }, null, 8, _hoisted_10)])]), _createElementVNode("tr", null, [_hoisted_11, _createElementVNode("td", null, _toDisplayString(_ctx.resData.province), 1)]), _createElementVNode("tr", null, [_hoisted_12, _createElementVNode("td", null, _toDisplayString(_ctx.resData.admissionTicket), 1)]), _createElementVNode("tr", null, [_hoisted_13, _createElementVNode("td", null, _toDisplayString(_ctx.resData.examStartTime) + " - " + _toDisplayString(_ctx.resData.examEndTime), 1)]), _hoisted_14, _createElementVNode("tr", null, [_hoisted_15, _createElementVNode("td", null, _toDisplayString(_ctx.resData.name), 1)]), _createElementVNode("tr", null, [_hoisted_16, _createElementVNode("td", null, _toDisplayString(_ctx.resData.sex === 1 ? '男' : '女'), 1)]), _createElementVNode("tr", null, [_hoisted_17, _createElementVNode("td", null, _toDisplayString(_ctx.resData.cardNo), 1)]), _createElementVNode("tr", null, [_hoisted_18, _createElementVNode("td", null, _toDisplayString(_ctx.resData.schoolName), 1)]), _createElementVNode("tr", null, [_hoisted_19, _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.resData.examPlace), 1)]), _createElementVNode("tr", null, [_hoisted_21, _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.resData.seatNum), 1)])])]), _hoisted_23])])];
        }),
        _: 1
      }, 8, ["spinning"]), _createElementVNode("div", _hoisted_24, [_createVNode(_component_a_button, {
        type: "primary",
        shape: "round",
        size: "large",
        class: "btn-download",
        onClick: _ctx.onDownloadClick,
        loading: _ctx.loading
      }, {
        default: _withCtx(function () {
          return [_hoisted_25];
        }),
        _: 1
      }, 8, ["onClick", "loading"])])];
    }),
    _: 1
  }, 8, ["visible"]);
}